module.exports = __webpack_public_path__ + "img/claimed.a51d240d.svg";